export enum GatewaysList {
    cobrefacil = 'cobrefacil',
    cielo = 'cielo',
    mercadopago = 'mercadopago',
    //asaas = 'asaas',
    pagarme = 'pagarme',
}
